import { createApiClient } from "../config/ApiConfig";

const API = createApiClient(`${process.env.REACT_APP_BACKEND_URI}/api/tickets`);







// GET ALL TICKETS

export const getTickets = async(

    search = "",

    status = "",

    priority = "",

    category = "",

    sortBy = "",

    employeeId = null

)=>{


    const response = await API.get(

        "/",

        {

            params:{


                search,

                status,

                priority,

                category,

                sortBy,

                employee_id: employeeId


            }

        }

    );



    return response.data;


};









// GET SINGLE TICKET

export const getTicket = async(

    ticketId

)=>{


    const response = await API.get(

        `/${ticketId}`

    );


    return response.data;


};









// CREATE TICKET

export const createTicket = async(

    data

)=>{


    const response = await API.post(

        "/",

        data

    );


    return response.data;


};









// UPDATE TICKET

export const updateTicket = async(

    ticketId,

    data

)=>{


    const response = await API.put(

        `/${ticketId}`,

        data

    );


    return response.data;


};









// ASSIGN TICKET

export const assignTicket = async(

    ticketId,

    employeeId

)=>{


    const response = await API.patch(

        `/${ticketId}/assign/${employeeId}`

    );


    return response.data;


};









// CLOSE TICKET

export const closeTicket = async(

    ticketId

)=>{


    const response = await API.patch(

        `/${ticketId}/close`

    );


    return response.data;


};









// DELETE TICKET

export const deleteTicket = async(

    ticketId,

    deleteRelated = false

)=>{


    const response = await API.delete(

        `/${ticketId}`,

        {

            params:{

                delete_related: deleteRelated

            }

        }

    );


    return response.data;


};







// UPDATE TICKET STATUS

export const updateTicketStatus = async(

    ticketId,

    statusName,

    employeeId

)=>{


    const response = await API.patch(

        `/${ticketId}/status`,

        {

            status_name: statusName,

            employee_id: employeeId

        }

    );


    return response.data;


};




export default API;